import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../store';
import { AuthUserData } from '../models/user';

const useGetUserData = (options?: { skip?: boolean }): AuthUserData | null => {
  const { business_id: businessId } = useParams();
  if (options?.skip) {
    return null;
  }
  if (!businessId || !businessId) {
    throw new Error('no business_id');
  }
  const { user: userData } = useSelector(
    (state: RootState) => state.auth,
  );
  return userData;
};

export default useGetUserData;
